import React, { useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header";
const ChatAiDemo = () => {
  const [show, setShow] = useState(false);
  const handleShow2 = () => setShow(true);

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Chat AI Setting<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <Link
                            to="#"
                            className="btn btn-primary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_chat"
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Flush Cache
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={handleShow2}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Chat Ai Demo
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                    {/* form */}
                    <div className="row align-items-center">
                      <div className="col-md-12">
                        <div className="form-group ">
                          <label className="form-label">Access Token</label>
                          <div className="input-group mb-3">
                            <span className="input-group-text ">
                              <i className="ti-user"></i>
                            </span>
                            <input type="text" className="form-control"></input>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group ">
                          <label className="form-label">Introduction </label>
                          <div className="input-group mb-3">
                            <textarea className="form-control"></textarea>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group ">
                          <label className="form-label">Description </label>
                          <div className="input-group mb-3">
                            <textarea
                              className="form-control"
                              rows={5}
                              cols={50}
                              placeholder="Type here..."
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-primary"
                        
                      >
                        Submit
                      </button>
                    </div>
                    {/* form*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}

        {/* Delete Lead */}
        <div className="modal fade" id="delete_chat" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove cache?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> lead you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Lead */}
      </>
    </>
  );
};

export default ChatAiDemo;
